import L from "leaflet";

export const pointsIcon = new L.Icon({
    iconUrl: "/images/map/map-marker-96.png",
    iconSize: [23, 40],
    iconAnchor: [9, 40],
    popupAnchor: [0, -32]
});


export const redIcon = new L.Icon({
    iconUrl: "/images/map/map-marker-red.svg",
    iconSize: [40, 40],
    iconAnchor: [20, 40],
    popupAnchor: [0, -32]
});


export const greenIcon = new L.Icon({
    iconUrl: "/images/map/map-marker-green.svg",
    iconSize: [40, 40],
    iconAnchor: [20, 40],
    popupAnchor: [0, -32]
});


export const blueIcon = new L.Icon({
    iconUrl: "/images/map/map-marker-blue.svg",
    iconSize: [40, 40],
    iconAnchor: [20, 40],
    popupAnchor: [0, -32]
});


export const createIcon = (id) =>
    L.divIcon({
        className: '',
        html: `
            <div class="marker-container">
                <img src="/images/map/map-marker-blue.svg" width="28"  alt=""/>
                <span class="marker-label">${id}</span>
            </div>
        `,
        iconSize: [60, 32],
        iconAnchor: [14, 32]
    });